module.exports = __webpack_public_path__ + "img/jdcx.a3d133db.png";